import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20artistic%20background%20with%20soft%20gradients%20in%20peach%20and%20cream%20tones%2C%20abstract%20flowing%20shapes%20reminiscent%20of%20comic%20panel%20layouts%2C%20gentle%20curves%20and%20waves%2C%20minimalist%20modern%20aesthetic%2C%20clean%20composition%2C%20warm%20atmosphere&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-primary-700/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-white mb-4">
          立即开始您的韩漫阅读之旅
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
          加入数百万韩漫爱好者的行列，通过我们的漫画网址享受免费漫画下拉式阅读。韩漫在线观看，随时随地畅享精彩故事。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-primary-600 rounded-full font-label text-sm font-medium hover:bg-white/95 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line" style={{ width: '18px', height: '18px' }}></i>
            浏览全部漫画
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-label text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line" style={{ width: '18px', height: '18px' }}></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}